import React from "react";
import styles from "./style.module.scss";
import logo from "../../assets/images/JaguarTCSRacingLogoWhite.png";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../authConfig";
import { brandColours } from "../../assets/brandColours";
import UnauthenticatedLayout from "../../components/Layout/unauthenticatedLayout";

function LoginPage() {
  const { instance } = useMsal();

  const handleLoginPopup = () => {
    instance.loginPopup(loginRequest).catch((error) => console.log(error));
  };

  const handleLoginRedirect = () => {
    instance.loginRedirect(loginRequest).catch((error) => console.log(error));
  };

  const account = instance.getActiveAccount();
  const isAuthenticated = !!account;
  if (isAuthenticated) {
    window.location.replace("/");
  }

  const isMobile =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent,
    );

  return (
    <UnauthenticatedLayout title={""} showVersion={true}>
      <div className={styles.container}>
        <div className={styles.main}>
          <div className={styles.loginBox}>
            <div className={styles.jaguarLogo}>
              <img src={logo} alt="Jaguar TCS Racing Logo"></img>
            </div>
            <button
              onClick={isMobile ? handleLoginRedirect : handleLoginPopup}
              style={{
                background: `linear-gradient(90deg, ${brandColours.gold} 0%, black 200%)`,
              }}
            >
              Sign In
            </button>
          </div>
        </div>
      </div>
    </UnauthenticatedLayout>
  );
}

export default LoginPage;
